import { api } from "./client";

export interface SensorPoint {
  captured_at: string;
  value: number;
}

export interface SensorSeries {
  key: string;
  label: string;
  unit: string | null;
  points: SensorPoint[];
}

export const sensorsApi = {
  list: (deviceId: string, hours = 48) =>
    api.get<{ series: SensorSeries[] }>(
      `/api/dashboard/devices/${deviceId}/sensors?hours=${hours}`,
    ),
};
